
// react
import React  from 'react';

import { useHistory } from 'react-router-dom';
import Login  from './Login'
import ForgotPassword  from './ForgotPassword'
import Register  from './Register'
import RegisterPhys  from './RegisterPhys'

export default function LoginBlock(props) { 

    return (
        <div>     
            {props.login ?
                <div>
                    <Login close={props.close} clicked={props.clicked} closeModal={props.closeModal}/>
                </div>
                : ''}
            {props.forgot ?
                <div>
                    <ForgotPassword close={props.close} clicked={props.clicked} closeModal={props.closeModal}/>
                </div>
                : ''}
            {props.reg ?
                <div>
                    <Register  close={props.close} clicked={props.clicked} reg={props.reg}/>
                </div>

                : ''}
            {props.sign ?
                <div>
                    <RegisterPhys  close={props.close} clicked={props.clicked} sign={props.sign}/>
                </div>
                : ''}
        </div>
    );
}
